import React from 'react';
import { Group, Path, Rect } from 'react-konva';

const PreflightWarningIcon = ({ x = 0, y = 0, width = 24, height = 24, fill = 'black', stroke = 'none', strokeWidth = 0, scale = { x: 1, y: 1 }, opacity = 1, listening = false, offsetX = 0, offsetY = 0, renderAsSVG = false }) => {
  return renderAsSVG ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      opacity={opacity}
    >
      <g>
        <path d="M2.401,4.161v15.678c0,2.183,1.775,3.957,3.959,3.957h11.281c2.182,0,3.957-1.774,3.957-3.957V7.604V6.997l-0.43-0.43&#10;&#9;&#9;l-5.936-5.934l-0.428-0.43h-0.607H6.36C4.177,0.204,2.401,1.979,2.401,4.161z M3.867,19.839V4.163c0-1.377,1.116-2.492,2.491-2.492&#10;&#9;&#9;h7.839v3.857c0,1.146,0.931,2.076,2.076,2.076h3.856v12.234c0,1.377-1.116,2.492-2.491,2.492H6.358&#10;&#9;&#9;C4.983,22.331,3.867,21.216,3.867,19.839L3.867,19.839z" />
        <path d="M12.751,8.253c-0.413-0.714-1.09-0.714-1.503,0l-5.497,9.494c-0.413,0.714-0.077,1.298,0.749,1.298h11&#10;&#9;&#9;c0.825,0,1.162-0.584,0.748-1.298L12.751,8.253z M11.246,11.113c0.415-0.714,1.092-0.714,1.507,0l2.932,5.047&#10;&#9;&#9;c0.414,0.713,0.078,1.297-0.747,1.297H9.063c-0.825,0-1.161-0.584-0.747-1.297L11.246,11.113z" />
        <path d="M12,17.135c0.18,0,0.331-0.06,0.454-0.182c0.122-0.122,0.183-0.273,0.183-0.453s-0.061-0.332-0.183-0.453&#10;&#9;&#9;c-0.123-0.122-0.273-0.185-0.454-0.185c-0.181,0-0.331,0.063-0.454,0.185c-0.122,0.121-0.183,0.273-0.183,0.453&#10;&#9;&#9;s0.061,0.331,0.183,0.453C11.668,17.075,11.819,17.135,12,17.135z" />
        <rect x="11.363" y="12.045" width="1.272" height="3.183" />
      </g>
    </svg>
  ) : (
    <Group
      x={x}
      y={y}
      width={width}
      height={height}
      scale={scale}
      listening={listening}
      offsetX={offsetX}
      offsetY={offsetY}
      opacity={opacity}
    >
      <Path fill={fill} stroke={stroke} strokeWidth={strokeWidth} data="M2.401,4.161v15.678c0,2.183,1.775,3.957,3.959,3.957h11.281c2.182,0,3.957-1.774,3.957-3.957V7.604V6.997l-0.43-0.43&#10;&#9;&#9;l-5.936-5.934l-0.428-0.43h-0.607H6.36C4.177,0.204,2.401,1.979,2.401,4.161z M3.867,19.839V4.163c0-1.377,1.116-2.492,2.491-2.492&#10;&#9;&#9;h7.839v3.857c0,1.146,0.931,2.076,2.076,2.076h3.856v12.234c0,1.377-1.116,2.492-2.491,2.492H6.358&#10;&#9;&#9;C4.983,22.331,3.867,21.216,3.867,19.839L3.867,19.839z" />
      <Path fill={fill} stroke={stroke} strokeWidth={strokeWidth} data="M12.751,8.253c-0.413-0.714-1.09-0.714-1.503,0l-5.497,9.494c-0.413,0.714-0.077,1.298,0.749,1.298h11&#10;&#9;&#9;c0.825,0,1.162-0.584,0.748-1.298L12.751,8.253z M11.246,11.113c0.415-0.714,1.092-0.714,1.507,0l2.932,5.047&#10;&#9;&#9;c0.414,0.713,0.078,1.297-0.747,1.297H9.063c-0.825,0-1.161-0.584-0.747-1.297L11.246,11.113z" />
      <Path fill={fill} stroke={stroke} strokeWidth={strokeWidth} data="M12,17.135c0.18,0,0.331-0.06,0.454-0.182c0.122-0.122,0.183-0.273,0.183-0.453s-0.061-0.332-0.183-0.453&#10;&#9;&#9;c-0.123-0.122-0.273-0.185-0.454-0.185c-0.181,0-0.331,0.063-0.454,0.185c-0.122,0.121-0.183,0.273-0.183,0.453&#10;&#9;&#9;s0.061,0.331,0.183,0.453C11.668,17.075,11.819,17.135,12,17.135z" />
      <Rect fill={fill} stroke={stroke} strokeWidth={strokeWidth} data="11.363" y="12.045" width="1.272" height="3.183" />
    </Group>
  );
};

export default PreflightWarningIcon;